import Analytics from '@hh.ru/analytics-js';
import { ElementSpyInstance } from 'bloko/common/elementSpy';

export enum ResumeSearchContextSource {
    Banner = 'banner',
    Title = 'title',
    VacancySelector = 'vacancy_selector',
}

export enum ResumeSearchContextAction {
    Apply = 'apply',
    Select = 'select',
    Change = 'change',
    Close = 'close',
}

export interface AnalyticsParams {
    vacancyId?: number;
    filters?: string;
    selectedVacancyId?: number;
    selectedFilters?: string;
    employerId: string;
    employerManagerId: string;
    hhtmSourceLabel: ResumeSearchContextSource;
}

export const sendEventElementShown = (element: HTMLElement, analyticsParams: AnalyticsParams): ElementSpyInstance =>
    Analytics.sendHHEventElementShown(element, {
        elementName: 'resume_search_context',
        ...analyticsParams,
    });

export const sendEventAction = (action: ResumeSearchContextAction, analyticsParams: AnalyticsParams): void =>
    Analytics.sendHHEventButtonClick(`resume_search_context_${action}`, analyticsParams);
